<template>
  <div>
    <div style="display: inline-block; vertical-align: top; margin-right:10px">
      <img alt="Courtier" src="./../../assets/user.png" width="48" />
    </div>
    <div style="display: inline-block">
      <strong>{{ courtier.first_name }} {{ courtier.last_name }}</strong>
      <br />
      <span>
        <strong>{{ courtier.identity }} {{ courtier.name }}</strong>
      </span>
      -
      <span>
        <em>{{ courtier.internal_number }}</em>
      </span>
    </div>
  </div>

  <a-divider></a-divider>

  <div>
    <div>
      <div>
        <label>Adresse</label>
        <a-input :disabled="!editMode" v-model:value="courtier.address" />
      </div>
      <div>
        <label>Adresse complémentaire</label>
        <a-input
          :disabled="!editMode"
          v-model:value="courtier.additional_address"
        />
      </div>
    </div>
    <div>
      <div>
        <label>Code postal</label>
        <a-input :disabled="!editMode" v-model:value="courtier.zip_code" />
      </div>
      <div>
        <label>Ville</label>
        <a-input :disabled="!editMode" v-model:value="courtier.city" />
      </div>
    </div>
    <div>
      <div>
        <label>Téléphone portable</label>
        <a-input :disabled="!editMode" v-model:value="courtier.tel_mobile" />
      </div>
      <div>
        <label>Téléphone fixe</label>
        <a-input :disabled="!editMode" v-model:value="courtier.tel_home" />
      </div>
    </div>
    <div>
      <div>
        <label>Adresse mail</label>
        <a-input :disabled="true" v-model:value="courtier.email" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myinfo",

  data: () => {
    return {
      editMode: false,
      page: "courtier",
      add_form: false,

      showMessage: false,
      messageText: "",

      showErrorMessage: false,
      errorMessageText: "",

      changeWhat: "INFO",

      originalInfo: [],

      pass: {
        old: "",
        passOne: "",
        passTwo: "",
      },

      co: {
        id: null,
        mailCourtier: "",
        prenomCourtier: "",
        nomCourtier: "",
        telP: "",
        telF: "",
      },
    };
  },
  watch: {},
  methods: {
    reset() {
      this.pass.old = "";
      this.pass.passOne = "";
      this.pass.passTwo = "";
    },
    cancel() {
      this.reset();
      this.editMode = false;
      this.changeWhat = "INFO";

      this.showMessage = false;
      this.showErrorMessage = false;

      this.courtier.adresse = this.originalInfo.adresse;
      this.courtier.adresse_suite = this.originalInfo.adresse_suite;
      this.courtier.cp = this.originalInfo.cp;
      this.courtier.ville = this.originalInfo.ville;
      this.courtier.tel_p = this.originalInfo.tel_p;
      this.courtier.tel_f = this.originalInfo.tel_f;
    },
    edit(what) {
      this.changeWhat = what;
      this.editMode = true;
    },
    save() {
      this.showErrorMessage = false;

      if (this.changeWhat == "PASS") {
      }

      this.axios
        .post("modifCourtier", {
          courtier: this.courtier,
          pass: this.pass,
          changeWhat: this.changeWhat,
        })
        .then((r) => {
          if (r.data.status == false) {
            this.showErrorMessage = true;
            this.errorMessageText = r.data.errorMessage;
            return;
          }

          if (r.data.status == true) {
            this.showMessage = true;

            if (this.changeWhat == "INFO")
              this.messageText =
                "Votre demande sera traitée dans les meilleurs délais";
            if (this.changeWhat == "PASS")
              this.messageText = "Votre mot de passe a été modifié";

            this.editMode = false;
            this.changeWhat = "INFO";

            setTimeout(() => {
              this.showMessage = false;
            }, 5000);

            this.reset();
          }
        });
    },
    addCoUser() {
      this.errorMessageText = "";

      this.co = new Object();

      this.co.id = null;
      this.co.mailCourtier = "";
      this.co.prenomCourtier = "";
      this.co.nomCourtier = "";
      this.co.telP = "";
      this.co.telF = "";
      this.add_form = true;
    },
    createCoUser() {
      this.errorMessageText = "";
      this.axios.post("createCoUser", this.co).then((r) => {
        if (r.data.status == true) {
          if (this.co.id == null) {
            this.$store.state.coBrokers.push({
              id: r.data.id,
              mailCourtier: this.co.mailCourtier,
              prenomCourtier: this.co.prenomCourtier,
              nomCourtier: this.co.nomCourtier,
              telP: this.co.telP,
              telF: this.co.telF,
              active: "0",
            });
          }
          this.add_form = false;
        }
        if (r.data.status == false) {
          this.errorMessageText = r.data.errorMesage;
        }
      });
    },
    editCoUser(id) {
      this.users.filter((u) => {
        if (id == u.id) this.co = u;
      });
      this.add_form = true;
    },
    deleteCoUser(id) {
      var r = confirm("Êtes-vous sûr ?");
      if (r == true) {
        this.axios.post("deleteCoUser/" + id).then((r) => {
          if (r.data.status == true) {
            this.users.filter((u, k) => {
              if (id == u.id) this.users.splice(k, 1);
            });
          }
          if (r.data.status == false) {
            console.log("error");
          }
        });
      }
    },
    cancelCo() {
      this.add_form = false;
    },
  },
  computed: {
    courtier() {
      return this.$store.getters.broker;
    },
    isRootBroker() {
      return this.courtier.type === "ROOT";
    },
    users() {
      return this.$store.state.coBrokers;
    },
  },
  mounted() {
    Object.assign(this.originalInfo, this.courtier);
  },
};
</script>
    